module.exports = __webpack_public_path__ + "img/icon-top-arrow.dca02a7a.svg";